export default __webpack_public_path__ + "static/media/personalization.a21b59e0.svg";